"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constant = require("../constant");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * @Author: zzy
 * @Date: 2022-12-15 16:34:15
 * @Desc: 箭头线
 */
var _default2 = exports.default = {
  name: 'SFCArrowLine',
  props: {
    showArrow: {
      type: Boolean,
      default: true
    },
    // color:{
    //   type: String,
    //   default: '#dedede'
    // },
    data: {
      type: [Object, null],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      vertical: _constant.store.vertical
    };
  }
};